// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"19e60903","703":"8cb041ea","787":"a651d897"}[chunkId] + ".chunk.js";
};